import React from 'react'
import { useTranslation } from 'react-i18next'
import preloadingimage from '../../assets/preloading-img.svg'
import ProgressBar from '../ProgressBar/ProgressBar'
import './PreLoadingScreen.css'

const PreLoadingScreen = (props) => {
    const { t, i18n } = useTranslation()

    return (
        <div className="preloadingscreen">
            <div className="preloadingscreen-content">
                <span className="msg">{t('Please wait')}</span>
                <span className="msg-detail">{props.text}</span>
                <img className="loading-img" src={preloadingimage} />
                {props.isLoaderVisible ? (
                    <>
                        <div className="spinner1"></div>
                        <div className="message1">{t('Loading')}</div>
                    </>
                ) : null}
                {props.hideProgressBar !== true ? (
                    <div>
                        <ProgressBar
                            margin={'auto'}
                            done={props.done}
                            barwidth={'90%'}
                            bgcolor={'#fff'}
                            barcolor={'#00b0f5'}
                            barheight="24px"
                            opacity={'1'}
                            padding={'2px'}
                        />
                        <span className="msg">
                            {props.done}% {t('Completed')}
                        </span>
                    </div>
                ) : null}
            </div>
        </div>
    )
}
export default PreLoadingScreen
